import { render, staticRenderFns } from "./SingleScopeMonthlyEmission.vue?vue&type=template&id=16b0482c&scoped=true"
import script from "./SingleScopeMonthlyEmission.vue?vue&type=script&lang=js"
export * from "./SingleScopeMonthlyEmission.vue?vue&type=script&lang=js"
import style0 from "./SingleScopeMonthlyEmission.vue?vue&type=style&index=0&id=16b0482c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0482c",
  null
  
)

export default component.exports